import React from "react";
import { Grid } from "@material-ui/core";
import { Typography } from "@mui/material";
import { yellow } from "@mui/material/colors";

export const BlockCreditMessage = ({ block = false }) => {
  return (
    <>
      {block && (
        <Grid item xs={12}>
          <Typography
            variant="body1"
            sx={{
              color: yellow[800],
              textAlign: "center",
            }}
          >
            Las ventas a crédito deben hacerse desde la unidad portátil asignada
            como <strong>Andén</strong>, no desde la unidad de planta.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: yellow[800],
              textAlign: "center",
            }}
          >
            Revisa que estés usando la correcta para que pueda procesarse en
            Oracle.
          </Typography>
        </Grid>
      )}
    </>
  );
};
